import { render, staticRenderFns } from "./ConsultoriaAnexosExcluir.vue?vue&type=template&id=11bab5be"
import script from "./ConsultoriaAnexosExcluir.vue?vue&type=script&lang=js"
export * from "./ConsultoriaAnexosExcluir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports